export const CONFIG = {
  ACCOUNT: {
    GRIDCOLUMNS_config_myInfo_Tokens: 'GRIDCOLUMNS_config_myInfo_Tokens',
    GRIDCOLUMNS_config_userUserGroup_userList: 'GRIDCOLUMNS_config_userUserGroup_userList',
    GRIDCOLUMNS_config_permission_targetList: 'GRIDCOLUMNS_config_permission_targetList',
    GRIDCOLUMNS_config_permission_targetList_alias:
      'GRIDCOLUMNS_config_permission_targetList_alias',
    GRIDCOLUMNS_config_permission_targetWindow_targetList:
      'GRIDCOLUMNS_config_permission_targetWindow_targetList',
    GRIDCOLUMNS_config_permission_targetWindow_targetList_alias:
      'GRIDCOLUMNS_config_permission_targetWindow_targetList_alias',
    GRIDCOLUMNS_config_permission_targetUserGroup: 'GRIDCOLUMNS_config_permission_targetUserGroup',
    GRIDCOLUMNS_config_permission_rolePermissionList:
      'GRIDCOLUMNS_config_permission_rolePermissionList',
    FILTERSEARCH_config_userUserGroup_userList: 'FILTERSEARCH_config_userUserGroup_userList',
    FILTERSEARCH_config_permission_targetList_application:
      'FILTERSEARCH_config_permission_targetList_application',
    FILTERSEARCH_config_permission_targetList_business:
      'FILTERSEARCH_config_permission_targetList_business',
    FILTERSEARCH_config_permission_targetList_cloud:
      'FILTERSEARCH_config_permission_targetList_cloud',
    FILTERSEARCH_config_permission_targetList_database:
      'FILTERSEARCH_config_permission_targetList_database',
    FILTERSEARCH_config_permission_targetList_external_resource:
      'FILTERSEARCH_config_permission_targetList_external_resource',
    FILTERSEARCH_config_permission_targetList_infrastructure:
      'FILTERSEARCH_config_permission_targetList_infrastructure',
    FILTERSEARCH_config_permission_targetList_kubernetes:
      'FILTERSEARCH_config_permission_targetList_kubernetes',
    FILTERSEARCH_config_permission_targetList_productIntegration:
      'FILTERSEARCH_config_permission_targetList_productIntegration',
    FILTERSEARCH_config_permission_targetWindow_targetList_application:
      'FILTERSEARCH_config_permission_targetWindow_targetList_application',
    FILTERSEARCH_config_permission_targetWindow_targetList_business:
      'FILTERSEARCH_config_permission_targetWindow_targetList_business',
    FILTERSEARCH_config_permission_targetWindow_targetList_cloud:
      'FILTERSEARCH_config_permission_targetWindow_targetList_cloud',
    FILTERSEARCH_config_permission_targetWindow_targetList_database:
      'FILTERSEARCH_config_permission_targetWindow_targetList_database',
    FILTERSEARCH_config_permission_targetWindow_targetList_external_resource:
      'FILTERSEARCH_config_permission_targetWindow_targetList_external_resource',
    FILTERSEARCH_config_permission_targetWindow_targetList_infrastructure:
      'FILTERSEARCH_config_permission_targetWindow_targetList_infrastructure',
    FILTERSEARCH_config_permission_targetWindow_targetList_kubernetes:
      'FILTERSEARCH_config_permission_targetWindow_targetList_kubernetes',
    FILTERSEARCH_config_permission_targetWindow_targetList_productIntegration:
      'FILTERSEARCH_config_permission_targetWindow_targetList_productIntegration',
  },
  PLATFORM: {
    TAB_config_cloudAccountDetail_selected: 'TAB_config_cloudAccountDetail_selected',
    GRIDCOLUMNS_config_infrastructure_hostList: 'GRIDCOLUMNS_config_infrastructure_hostList',
    GRIDCOLUMNS_config_infrastructure_hostListDetail_configList:
      'GRIDCOLUMNS_config_infrastructure_hostListDetail_configList',
    GRIDCOLUMNS_config_infrastructure_hostListDetail_configSetting:
      'GRIDCOLUMNS_config_infrastructure_hostListDetail_configSetting',
    GRIDCOLUMNS_config_infrastructure_networkObjectList:
      'GRIDCOLUMNS_config_infrastructure_networkObjectList',
    GRIDCOLUMNS_config_infrastructure_networkObjectList_all:
      'GRIDCOLUMNS_config_infrastructure_networkObjectList_all',
    GRIDCOLUMNS_config_infrastructure_networkObject_processList:
      'GRIDCOLUMNS_config_infrastructure_networkObject_processList',
    GRIDCOLUMNS_config_infrastructure_networkObject_window_processList:
      'GRIDCOLUMNS_config_infrastructure_networkObject_window_processList',
    GRIDCOLUMNS_config_infrastructure_networkDevice_deviceList:
      'GRIDCOLUMNS_config_infrastructure_networkDevice_deviceList',
    GRIDCOLUMNS_config_infrastructure_networkDevice_bulkDeviceList:
      'GRIDCOLUMNS_config_infrastructure_networkDevice_bulkDeviceList',
    GRIDCOLUMNS_config_infrastructure_oidPackManager_oidList:
      'GRIDCOLUMNS_config_infrastructure_oidPackManager_oidList',
    GRIDCOLUMNS_config_infrastructure_oidPackManagerAddGroup_oidList:
      'GRIDCOLUMNS_config_infrastructure_oidPackManagerAddGroup_oidList',
    GRIDCOLUMNS_config_infrastructure_messageQueue_messageQueueList:
      'GRIDCOLUMNS_config_infrastructure_messageQueue_messageQueueList',
    GRIDCOLUMNS_config_infrastructure_messageQueue_BrokerList:
      'GRIDCOLUMNS_config_infrastructure_messageQueue_BrokerList',
    GRIDCOLUMNS_config_cloud_resourceList: 'GRIDCOLUMNS_config_cloud_resourceList',
    GRIDCOLUMNS_config_cloud_resourceList_all: 'GRIDCOLUMNS_config_cloud_resourceList_all',
    GRIDCOLUMNS_config_cloud_accountList: 'GRIDCOLUMNS_config_cloud_accountList',
    GRIDCOLUMNS_config_cloud_accountList_aws: 'GRIDCOLUMNS_config_cloud_accountList_aws',
    GRIDCOLUMNS_config_cloud_accountList_azure: 'GRIDCOLUMNS_config_cloud_accountList_azure',
    GRIDCOLUMNS_config_cloud_accountDetail_resourceList:
      'GRIDCOLUMNS_config_cloud_accountDetail_resourceList',
    GRIDCOLUMNS_config_cloud_collectorList: 'GRIDCOLUMNS_config_cloud_collectorList',
    GRIDCOLUMNS_config_cloud_collectorTargetList: 'GRIDCOLUMNS_config_cloud_collectorTargetList',
    GRIDCOLUMNS_config_cloud_collectorDetail_configList:
      'GRIDCOLUMNS_config_cloud_collectorDetail_configList',
    GRIDCOLUMNS_config_kubernetes_namespaceList: 'GRIDCOLUMNS_config_kubernetes_namespaceList',
    GRIDCOLUMNS_config_kubernetes_exportFile_configList:
      'GRIDCOLUMNS_config_kubernetes_exportFile_configList',
    GRIDCOLUMNS_config_application_wasList: 'GRIDCOLUMNS_config_application_wasList',
    GRIDCOLUMNS_config_application_webServerList: 'GRIDCOLUMNS_config_application_webServerList',
    GRIDCOLUMNS_config_application_wasListDetail_configList:
      'GRIDCOLUMNS_config_application_wasListDetail_configList',
    GRIDCOLUMNS_config_application_wasListDetail_configSetting:
      'GRIDCOLUMNS_config_application_wasListDetail_configSetting',
    GRIDCOLUMNS_config_application_wasListDetail_targetConfigSetting:
      'GRIDCOLUMNS_config_application_wasListDetail_targetConfigSetting',
    GRIDCOLUMNS_config_application_url_monitoring_urlList:
      'GRIDCOLUMNS_config_application_url_monitoring_urlList',
    GRIDCOLUMNS_config_application_rumList: 'GRIDCOLUMNS_config_application_rumList',
    GRIDCOLUMNS_config_database_instance_instanceList:
      'GRIDCOLUMNS_config_database_instance_instanceList',
    GRIDCOLUMNS_config_database_instance_instanceList_all:
      'GRIDCOLUMNS_config_database_instance_instanceList_all',
    GRIDCOLUMNS_config_database_instance_instanceList_postgresql:
      'GRIDCOLUMNS_config_database_instance_instanceList_postgresql',
    GRIDCOLUMNS_config_database_instance_instanceList_redis:
      'GRIDCOLUMNS_config_database_instance_instanceList_redis',
    GRIDCOLUMNS_config_database_instance_instanceList_cubrid:
      'GRIDCOLUMNS_config_database_instance_instanceList_cubrid',
    GRIDCOLUMNS_config_database_instance_instanceList_mongodb:
      'GRIDCOLUMNS_config_database_instance_instanceList_mongodb',
    GRIDCOLUMNS_config_database_instance_instanceList_instance:
      'GRIDCOLUMNS_config_database_instance_instanceList_instance',
    GRIDCOLUMNS_config_database_cloud_metric_collection_target:
      'GRIDCOLUMNS_config_database_cloud_metric_collection_target',
    GRIDCOLUMNS_config_database_agentManagementListDetail_instanceList:
      'GRIDCOLUMNS_config_database_agentManagementListDetail_instanceList',
    GRIDCOLUMNS_config_database_instance_dbMetricCollection:
      'GRIDCOLUMNS_config_database_instance_dbMetricCollection',
    GRIDCOLUMNS_config_database_instance_customConfiguration:
      'GRIDCOLUMNS_config_database_instance_customConfiguration',
    GRIDCOLUMNS_config_database_instance_cloudMetricSelectCollector:
      'GRIDCOLUMNS_config_database_instance_cloudMetricSelectCollector',
    GRIDCOLUMNS_config_database_instance_cloudMetricManual:
      'GRIDCOLUMNS_config_database_instance_cloudMetricManual',
    GRIDCOLUMNS_config_database_instance_metricCollectionWindow:
      'GRIDCOLUMNS_config_database_instance_metricCollectionWindow',
    GRIDCOLUMNS_config_database_instance_cloudMetricCollectionWindow:
      'GRIDCOLUMNS_config_database_instance_cloudMetricCollectionWindow',
    GRIDCOLUMNS_config_userIntegration_targetList: 'GRIDCOLUMNS_config_userIntegration_targetList',
    GRIDCOLUMNS_config_userIntegration_statList: 'GRIDCOLUMNS_config_userIntegration_statList',
    GRIDCOLUMNS_config_targetConfigSetting_targetConfigList:
      'GRIDCOLUMNS_config_targetConfigSetting_targetConfigList',
    GRIDCOLUMNS_config_configDetail_configSetting: 'GRIDCOLUMNS_config_configDetail_configSetting',
    FILTERSEARCH_config_infrastructure_hostList: 'FILTERSEARCH_config_infrastructure_hostList',
    FILTERSEARCH_config_infrastructure_hostListDetail_configList:
      'FILTERSEARCH_config_infrastructure_hostListDetail_configList',
    FILTERSEARCH_config_infrastructure_deviceList: 'FILTERSEARCH_config_infrastructure_deviceList',
    FILTERSEARCH_config_infrastructure_oidList: 'FILTERSEARCH_config_infrastructure_oidList',
    FILTERSEARCH_config_infrastructure_networkObjectList:
      'FILTERSEARCH_config_infrastructure_networkObjectList',
    FILTERSEARCH_config_infrastructure_networkObject_processList:
      'FILTERSEARCH_config_infrastructure_networkObject_processList',
    FILTERSEARCH_config_infrastructure_networkObject_host_processList:
      'FILTERSEARCH_config_infrastructure_networkObject_host_processList',
    FILTERSEARCH_config_infrastructure_networkObject_window_processList:
      'FILTERSEARCH_config_infrastructure_networkObject_window_processList',
    FILTERSEARCH_config_infrastructure_messageQueueList:
      'FILTERSEARCH_config_infrastructure_messageQueueList',
    FILTERSEARCH_config_infrastructure_haConfig_host_haList:
      'FILTERSEARCH_config_infrastructure_haConfig_host_haList',
    FILTERSEARCH_config_infrastructure_haConfig_host_list:
      'FILTERSEARCH_config_infrastructure_haConfig_host_list',
    FILTERSEARCH_config_infrastructure_haConfig_host_selectedList:
      'FILTERSEARCH_config_infrastructure_haConfig_host_selectedList',
    FILTERSEARCH_config_infrastructure_haConfig_device_haList:
      'FILTERSEARCH_config_infrastructure_haConfig_device_haList',
    FILTERSEARCH_config_infrastructure_haConfig_device_list:
      'FILTERSEARCH_config_infrastructure_haConfig_device_list',
    FILTERSEARCH_config_infrastructure_haConfig_device_selectedList:
      'FILTERSEARCH_config_infrastructure_haConfig_device_selectedList',
    FILTERSEARCH_config_cloud_resourceList: 'FILTERSEARCH_config_cloud_resourceList',
    FILTERSEARCH_config_cloud_resourceList_all: 'FILTERSEARCH_config_cloud_resourceList_all',
    FILTERSEARCH_config_cloud_accountList: 'FILTERSEARCH_config_cloud_accountList',
    FILTERSEARCH_config_cloud_accountDetail_resourceList:
      'FILTERSEARCH_config_cloud_accountDetail_resourceList',
    FILTERSEARCH_config_cloud_collectorList: 'FILTERSEARCH_config_cloud_collectorList',
    FILTERSEARCH_config_cloud_collectorTargetList: 'FILTERSEARCH_config_cloud_collectorTargetList',
    FILTERSEARCH_config_cloud_accountList_aws: 'FILTERSEARCH_config_cloud_accountList_aws',
    FILTERSEARCH_config_cloud_accountList_azure: 'FILTERSEARCH_config_cloud_accountList_azure',

    FILTERSEARCH_config_cloud_collectorList_aws: 'FILTERSEARCH_config_cloud_collectorList_aws',
    FILTERSEARCH_config_cloud_collectorList_azure: 'FILTERSEARCH_config_cloud_collectorList_azure',

    FILTERSEARCH_config_cloud_metricSettingList: 'FILTERSEARCH_config_cloud_metricSettingList',
    FILTERSEARCH_config_kubernetes_namespaceList: 'FILTERSEARCH_config_kubernetes_namespaceList',
    FILTERSEARCH_config_application_wasList: 'FILTERSEARCH_config_application_wasList',
    FILTERSEARCH_config_application_webServerList: 'FILTERSEARCH_config_application_webServerList',
    FILTERSEARCH_config_application_wasGroupSettingList:
      'FILTERSEARCH_config_application_wasGroupSettingList',
    FILTERSEARCH_targetConfigSetting_targetConfigList:
      'FILTERSEARCH_targetConfigSetting_targetConfigList',
    FILTERSEARCH_configDetailSettingWindow_configDetailList:
      'FILTERSEARCH_configDetailSettingWindow_configDetailList',
    FILTERSEARCH_config_application_targetSettingList:
      'FILTERSEARCH_config_application_targetSettingList',
    FILTERSEARCH_config_application_configSettingList:
      'FILTERSEARCH_config_application_configSettingList',
    FILTERSEARCH_config_database_instance_instanceList:
      'FILTERSEARCH_config_database_instance_instanceList',
    FILTERSEARCH_config_database_instance_cloudMetricCollectionWindow:
      'FILTERSEARCH_config_database_instance_cloudMetricCollectionWindow',
    FILTERSEARCH_config_database_agentManagement_instanceList:
      'FILTERSEARCH_config_database_agentManagement_instanceList',
    FILTERSEARCH_config_database_instance_dbInformationSinglestore:
      'FILTERSEARCH_config_database_instance_dbInformationSinglestore',
    FILTERSEARCH_config_database_postgresql_databaseList:
      'FILTERSEARCH_config_database_postgresql_databaseList',
    FILTERSEARCH_config_user_integration_targetList:
      'FILTERSEARCH_config_user_integration_targetList',
    FILTERSEARCH_config_user_integration_statList: 'FILTERSEARCH_config_user_integration_statList',
    FILTERSEARCH_config_user_integration_collectionDataList:
      'FILTERSEARCH_config_user_integration_collectionDataList',
    FILTERSEARCH_config_user_integration_collectionLogList:
      'FILTERSEARCH_config_user_integration_collectionLogList',
    TOGGLE_config_cloudAccountDetail_info_expanded:
      'TOGGLE_config_cloudAccountDetail_info_expanded',
  },
  MONITORING: {
    GRIDCOLUMNS_config_business_businessList: 'GRIDCOLUMNS_config_business_businessList',
    GRIDCOLUMNS_config_log_loggingList: 'GRIDCOLUMNS_config_log_loggingList',
    GRIDCOLUMNS_config_log_loggingListDetail_accessLog:
      'GRIDCOLUMNS_config_log_loggingListDetail_accessLog',
    GRIDCOLUMNS_config_log_loggingListDetail_pathList:
      'GRIDCOLUMNS_config_log_loggingListDetail_pathList',
    GRIDCOLUMNS_config_log_pathList: 'GRIDCOLUMNS_config_log_pathList',
    GRIDCOLUMNS_config_log_pathListDetail_filePathGuide:
      'GRIDCOLUMNS_config_log_pathListDetail_filePathGuide',
    GRIDCOLUMNS_config_log_pathListDetail_config: 'GRIDCOLUMNS_config_log_pathListDetail_config',
    GRIDCOLUMNS_config_report_dashboardList: 'GRIDCOLUMNS_config_report_dashboardList',
    GRIDCOLUMNS_config_report_templateReportList: 'GRIDCOLUMNS_config_report_templateReportList',
    GRIDCOLUMNS_config_report_scheduleList: 'GRIDCOLUMNS_config_report_scheduleList',
    GRIDCOLUMNS_config_templateReport_dataBlocksList:
      'GRIDCOLUMNS_config_templateReport_dataBlocksList',
    GRIDCOLUMNS_config_report_businessList: 'GRIDCOLUMNS_config_report_businessList',
    GRIDCOLUMNS_config_report_scheduleListDetail_sendInformation:
      'GRIDCOLUMNS_config_report_scheduleListDetail_sendInformation',
    GRIDCOLUMNS_config_license_licenseList: 'GRIDCOLUMNS_config_license_licenseList',
    GRIDCOLUMNS_config_license_licenseTarget_List: 'GRIDCOLUMNS_config_license_licenseTarget_List',
    GRIDCOLUMNS_config_license_hostList: 'GRIDCOLUMNS_config_license_hostList',
    GRIDCOLUMNS_config_license_ndmList: 'GRIDCOLUMNS_config_license_ndmList',
    GRIDCOLUMNS_config_license_kafkaList: 'GRIDCOLUMNS_config_license_kafkaList',
    GRIDCOLUMNS_config_license_containerList: 'GRIDCOLUMNS_config_license_containerList',
    GRIDCOLUMNS_config_license_appContainerList: 'GRIDCOLUMNS_config_license_appContainerList',
    GRIDCOLUMNS_config_license_apmList: 'GRIDCOLUMNS_config_license_apmList',
    GRIDCOLUMNS_config_license_redisList: 'GRIDCOLUMNS_config_license_redisList',
    GRIDCOLUMNS_config_license_postgresqlList: 'GRIDCOLUMNS_config_license_postgresqlList',
    GRIDCOLUMNS_config_license_mysqlList: 'GRIDCOLUMNS_config_license_mysqlList',
    GRIDCOLUMNS_config_license_oracleList: 'GRIDCOLUMNS_config_license_oracleList',
    GRIDCOLUMNS_config_license_sqlServerList: 'GRIDCOLUMNS_config_license_sqlServerList',
    GRIDCOLUMNS_config_host_license_issuance_history:
      'GRIDCOLUMNS_config_host_license_issuance_history',
    GRIDCOLUMNS_config_database_license_issuance_history:
      'GRIDCOLUMNS_config_database_license_issuance_history',
    GRIDCOLUMNS_config_external_integration_externalIntegrationSettingList:
      'GRIDCOLUMNS_config_external_integration_externalIntegrationSettingList',
    GRIDCOLUMNS_config_external_integration_externalIntegrationProduct_userList:
      'GRIDCOLUMNS_config_external_integration_externalIntegrationProduct_userList',
    GRIDCOLUMNS_config_templateReport_scheduleList:
      'GRIDCOLUMNS_config_templateReport_scheduleList',
    GRIDCOLUMNS_config_templateReport_reportTab: 'GRIDCOLUMNS_config_templateReport_reportTab',

    FILTERSEARCH_config_business_businessList: 'FILTERSEARCH_config_business_businessList',
    FILTERSEARCH_config_log_loggingList: 'FILTERSEARCH_config_log_loggingList',
    FILTERSEARCH_config_log_pathList: 'FILTERSEARCH_config_log_pathList',
    FILTERSEARCH_config_log_addLoggingWindow: 'FILTERSEARCH_config_log_addLoggingWindow',
    FILTERSEARCH_config_report_dashboardList: 'FILTERSEARCH_config_report_dashboardList',
    FILTERSEARCH_config_report_templateReportList: 'FILTERSEARCH_config_report_templateReportList',
    FILTERSEARCH_config_report_scheduleList: 'FILTERSEARCH_config_report_scheduleList',
    FILTERSEARCH_config_templateReport_dataBlocksList:
      'FILTERSEARCH_config_templateReport_dataBlocksList',
    FILTERSEARCH_config_report_businessList: 'FILTERSEARCH_config_report_businessList',
    FILTERSEARCH_config_external_resource_externalResourceList:
      'FILTERSEARCH_config_external_resource_externalResourceList',
    FILTERSEARCH_config_external_integration_externalIntegrationProduct:
      'FILTERSEARCH_config_external_integration_externalIntegrationProduct',
    FILTERSEARCH_config_templateReport_scheduleList:
      'FILTERSEARCH_config_templateReport_scheduleList',

    FILTERSEARCH_config_templateReport_reportTab: 'FILTERSEARCH_config_templateReport_reportTab',
    FILTERSEARCH_config_predefinedReport_editPermission_userList:
      'FILTERSEARCH_config_predefinedReport_editPermission_userList',
    FILTERSEARCH_config_predefinedReport_modal_blockList:
      'FILTERSEARCH_config_predefinedReport_modal_blockList',
  },
  ALERT: {
    GRIDCOLUMNS_config_userAlert_ruleList: 'GRIDCOLUMNS_config_userAlert_ruleList',
    GRIDCOLUMNS_config_userAlertRuleSetting_ruleDataEventPreview:
      'GRIDCOLUMNS_config_userAlertRuleSetting_ruleDataEventPreview',
    GRIDCOLUMNS_config_userAlertRuleSetting_ruleDataEventLogging:
      'GRIDCOLUMNS_config_userAlertRuleSetting_ruleDataEventLogging',
    GRIDCOLUMNS_config_alertPreset_metricList: 'GRIDCOLUMNS_config_alertPreset_metricList',
    GRIDCOLUMNS_config_alertPreset_usageStatus: 'GRIDCOLUMNS_config_alertPreset_usageStatus',
    GRIDCOLUMNS_config_alertPreset_conditionList: 'GRIDCOLUMNS_config_alertPreset_conditionList',
    GRIDCOLUMNS_config_alertPreset_configHistory: 'GRIDCOLUMNS_config_alertPreset_configHistory',
    GRIDCOLUMNS_config_aiAnomalyDetection_instanceList:
      'GRIDCOLUMNS_config_aiAnomalyDetection_instanceList',
    GRIDCOLUMNS_config_notification_grid_slack: 'GRIDCOLUMNS_config_notification_grid_slack',
    GRIDCOLUMNS_config_notification_grid_telegram: 'GRIDCOLUMNS_config_notification_grid_telegram',
    GRIDCOLUMNS_config_notification_grid_webhook: 'GRIDCOLUMNS_config_notification_grid_webhook',
    GRIDCOLUMNS_config_systemAlert_hostList: 'GRIDCOLUMNS_config_systemAlert_hostList',
    GRIDCOLUMNS_config_systemAlert_deviceList: 'GRIDCOLUMNS_config_systemAlert_deviceList',
    GRIDCOLUMNS_config_systemAlert_nodeList: 'GRIDCOLUMNS_config_systemAlert_nodeList',
    GRIDCOLUMNS_config_systemAlert_wasList: 'GRIDCOLUMNS_config_systemAlert_wasList',
    GRIDCOLUMNS_config_systemAlert_instanceList: 'GRIDCOLUMNS_config_systemAlert_instanceList',
    GRIDCOLUMNS_config_systemAlert_messageQueueList:
      'GRIDCOLUMNS_config_systemAlert_messageQueueList',
    GRIDCOLUMNS_config_systemAlert_webServerList: 'GRIDCOLUMNS_config_systemAlert_webServerList',
    GRIDCOLUMNS_config_systemAlert_cloudList: 'GRIDCOLUMNS_config_systemAlert_cloudList',

    GRIDCOLUMNS_config_externalAlert_ruleList: 'GRIDCOLUMNS_config_externalAlert_ruleList',
    GRIDCOLUMNS_config_externalAlert_window_query: 'GRIDCOLUMNS_config_externalAlert_window_query',
    GRIDCOLUMNS_config_externalAlert_window_threshold:
      'GRIDCOLUMNS_config_externalAlert_window_threshold',
    GRIDCOLUMNS_config_notification_scheduleExclusionPeriod:
      'GRIDCOLUMNS_config_notification_scheduleExclusionPeriod',

    GRIDCOLUMNS_config_notification_slackNotificationList:
      'GRIDCOLUMNS_config_notification_slackNotificationList',
    GRIDCOLUMNS_config_notification_telegramNotificationList:
      'GRIDCOLUMNS_config_notification_telegramNotificationList',
    GRIDCOLUMNS_config_notification_mailSMTPNotificationList:
      'GRIDCOLUMNS_config_notification_mailSMTPNotificationList',
    GRIDCOLUMNS_config_notification_mailNCPNotificationList:
      'GRIDCOLUMNS_config_notification_mailNCPNotificationList',
    GRIDCOLUMNS_config_notification_smsDbNotificationList:
      'GRIDCOLUMNS_config_notification_smsDbNotificationList',
    GRIDCOLUMNS_config_notification_smsDbNotificationProvisionVariable:
      'GRIDCOLUMNS_config_notification_smsDbNotificationProvisionVariable',
    GRIDCOLUMNS_config_notification_smsNcpNotificationList:
      'GRIDCOLUMNS_config_notification_smsNcpNotificationList',
    GRIDCOLUMNS_config_notification_webhookNotificationList:
      'GRIDCOLUMNS_config_notification_webhookNotificationList',
    GRIDCOLUMNS_config_notification_kakaoNotificationList:
      'GRIDCOLUMNS_config_notification_kakaoNotificationList',
    FILTERSEARCH_config_userAlert_ruleList: 'FILTERSEARCH_config_userAlert_ruleList',
    FILTERSEARCH_config_userAlertRuleSetting_ruleDataEventServerChange:
      'FILTERSEARCH_config_userAlertRuleSetting_ruleDataEventServerChange',
    FILTERSEARCH_config_notification_grid_slack: 'FILTERSEARCH_config_notification_grid_slack',
    FILTERSEARCH_config_notification_grid_telegram:
      'FILTERSEARCH_config_notification_grid_telegram',
    FILTERSEARCH_config_notification_grid_webhook: 'FILTERSEARCH_config_notification_grid_webhook',
    FILTERSEARCH_config_systemAlert_infra: 'FILTERSEARCH_config_systemAlert_infra',
    FILTERSEARCH_config_systemAlert_kube: 'FILTERSEARCH_config_systemAlert_kube',
    FILTERSEARCH_config_systemAlert_app: 'FILTERSEARCH_config_systemAlert_app',
    FILTERSEARCH_config_systemAlert_db: 'FILTERSEARCH_config_systemAlert_db',
    FILTERSEARCH_config_systemAlert_network: 'FILTERSEARCH_config_systemAlert_network',
    FILTERSEARCH_config_systemAlert_messageQueue: 'FILTERSEARCH_config_systemAlert_messageQueue',
    FILTERSEARCH_config_systemAlert_webServer: 'FILTERSEARCH_config_systemAlert_webServer',
    FILTERSEARCH_config_systemAlert_cloud: 'FILTERSEARCH_config_systemAlert_cloud',
    FILTERSEARCH_config_notification_slackNotificationList:
      'FILTERSEARCH_config_notification_slackNotificationList',
    FILTERSEARCH_config_notification_telegramNotificationList:
      'FILTERSEARCH_config_notification_telegramNotificationList',
    FILTERSEARCH_config_notification_mailSmtpNotificationList:
      'FILTERSEARCH_config_notification_mailSmtpNotificationList',
    FILTERSEARCH_config_notification_mailNcpNotificationList:
      'FILTERSEARCH_config_notification_mailNcpNotificationList',
    FILTERSEARCH_config_notification_smsDbNotificationList:
      'FILTERSEARCH_config_notification_smsDbNotificationList',
    FILTERSEARCH_config_notification_smsNcpNotificationList:
      'FILTERSEARCH_config_notification_smsNcpNotificationList',
    FILTERSEARCH_config_notification_webhookNotificationList:
      'FILTERSEARCH_config_notification_webhookNotificationList',
    FILTERSEARCH_config_notification_kakaoNotificationList:
      'FILTERSEARCH_config_notification_kakaoNotificationList',
    FILTERSEARCH_config_alertPreset_metricList: 'FILTERSEARCH_config_alertPreset_metricList',
    FILTERSEARCH_config_alertPreset_usageStatus: 'FILTERSEARCH_config_alertPreset_usageStatus',
    FILTERSEARCH_config_alertPreset_configHistory: 'FILTERSEARCH_config_alertPreset_configHistory',
    FILTERSEARCH_config_alertPreset_conditionList: 'FILTERSEARCH_config_alertPreset_conditionList',
    FILTERSEARCH_config_aiAnomalyDetection_instanceList:
      'FILTERSEARCH_config_aiAnomalyDetection_instanceList',
  },
  ASSET: {
    TAB_config_eolPolicyDetail_selected: 'TAB_config_eolPolicyDetail_selected',
    GRIDCOLUMNS_config_eolEos_eolTargetList: 'GRIDCOLUMNS_config_eolEos_eolTargetList',
    GRIDCOLUMNS_config_eolEos_eolTargetWindow: 'GRIDCOLUMNS_config_eolEos_eolTargetWindow',
    GRIDCOLUMNS_config_eolEos_eolPolicyList: 'GRIDCOLUMNS_config_eolEos_eolPolicyList',
    GRIDCOLUMNS_config_eolEos_eolPolicyTarget: 'GRIDCOLUMNS_config_eolEos_eolPolicyTarget',
    GRIDCOLUMNS_config_eolEos_eolPolicyChangeHistory:
      'GRIDCOLUMNS_config_eolEos_eolPolicyChangeHistory',
    GRIDCOLUMNS_config_eolEos_eolPolicy_addPolicyOs:
      'GRIDCOLUMNS_config_eolEos_eolPolicy_addPolicyOs',

    FILTERSEARCH_config_eolEos_eolTargetList: 'FILTERSEARCH_config_eolEos_eolTargetList',
    FILTERSEARCH_config_eolEos_eolTargetWindow: 'FILTERSEARCH_config_eolEos_eolTargetWindow',
    FILTERSEARCH_config_eolEos_eolPolicyList: 'FILTERSEARCH_config_eolEos_eolPolicyList',
    FILTERSEARCH_config_eolEos_eolPolicyTarget: 'FILTERSEARCH_config_eolEos_eolPolicyTarget',
    FILTERSEARCH_config_eolEos_eolPolicyChangeHistory:
      'FILTERSEARCH_config_eolEos_eolPolicyChangeHistory',
    FILTERSEARCH_config_eolEos_eolPolicy_addPolicyOs:
      'FILTERSEARCH_config_eolEos_eolPolicy_addPolicyOs',
    TOGGLE_config_eolPolicyDetail_info_expanded: 'TOGGLE_config_eolPolicyDetail_info_expanded',
  },
  MANAGEMENT: {
    TAB_config_agentDetail_selected: 'TAB_config_agentDetail_selected',
    TAB_config_usageTrendSlide_selected: 'TAB_config_usageTrendSlide_selected',
    GRIDCOLUMNS_config_notice_noticeList: 'GRIDCOLUMNS_config_notice_noticeList',
    GRIDCOLUMNS_config_agent_agentList: 'GRIDCOLUMNS_config_agent_agentList',
    GRIDCOLUMNS_config_agent_agentList_agentBulkWindow:
      'GRIDCOLUMNS_config_agent_agentList_agentBulkWindow',
    GRIDCOLUMNS_config_agent_agentListDetail_agentTarget:
      'GRIDCOLUMNS_config_agent_agentListDetail_agentTarget',
    GRIDCOLUMNS_config_agent_agentListDetail_agentPatchHistory:
      'GRIDCOLUMNS_config_agent_agentListDetail_agentPatchHistory',
    GRIDCOLUMNS_config_agent_patchFileList: 'GRIDCOLUMNS_config_agent_patchFileList',
    GRIDCOLUMNS_config_agent_patchAgentList: 'GRIDCOLUMNS_config_agent_patchAgentList',
    GRIDCOLUMNS_config_agent_patchResultList: 'GRIDCOLUMNS_config_agent_patchResultList',
    GRIDCOLUMNS_config_agent_patchHistoryList: 'GRIDCOLUMNS_config_agent_patchHistoryList',
    GRIDCOLUMNS_config_agent_uploadFileList: 'GRIDCOLUMNS_config_agent_uploadFileList',
    GRIDCOLUMNS_config_agent_uploadFileResultList: 'GRIDCOLUMNS_config_agent_uploadFileResultList',
    GRIDCOLUMNS_config_tag_valueList: 'GRIDCOLUMNS_config_tag_valueList',
    GRIDCOLUMNS_config_dataRetention_tableList: 'GRIDCOLUMNS_config_dataRetention_tableList',
    GRIDCOLUMNS_config_dataRetentionUsageTrend_tableList:
      'GRIDCOLUMNS_config_dataRetentionUsageTrend_tableList',
    GRIDCOLUMNS_config_dataRetentionUsageTrend_retentionSetting:
      'GRIDCOLUMNS_config_dataRetentionUsageTrend_retentionSetting',
    GRIDCOLUMNS_config_data_TargetOfMetricCollectionList:
      'GRIDCOLUMNS_config_data_targetOfMetricCollectionList',
    GRIDCOLUMNS_config_data_metricCollectionList: 'GRIDCOLUMNS_config_data_metricCollectionList',
    GRIDCOLUMNS_config_data_metricCollectionDetail_settingList:
      'GRIDCOLUMNS_config_data_metricCollectionDetail_settingList',
    GRIDCOLUMNS_config_data_statList: 'GRIDCOLUMNS_config_data_statList',
    GRIDCOLUMNS_config_customStat_scheduleList: 'GRIDCOLUMNS_config_customStat_scheduleList',
    GRIDCOLUMNS_config_customStat_collectionLogList:
      'GRIDCOLUMNS_config_customStat_collectionLogList',
    GRIDCOLUMNS_config_customStat_collectionTestResultList:
      'GRIDCOLUMNS_config_customStat_collectionTestResultList',
    GRIDCOLUMNS_config_customStat_metricMappingValueList:
      'GRIDCOLUMNS_config_customStat_metricMappingValueList',
    GRIDCOLUMNS_config_accessPolicy_loginIpControlList:
      'GRIDCOLUMNS_config_accessPolicy_loginIpControlList',
    GRIDCOLUMNS_config_accessPolicy_loginFailHistoryList:
      'GRIDCOLUMNS_config_accessPolicy_loginFailHistoryList',

    GRIDCOLUMNS_config_targetIcon_targetIconList_host:
      'GRIDCOLUMNS_config_targetIcon_targetIconList_host',
    GRIDCOLUMNS_config_targetIcon_targetIconList_network:
      'GRIDCOLUMNS_config_targetIcon_targetIconList_network',
    GRIDCOLUMNS_config_targetIcon_targetIconList_npm:
      'GRIDCOLUMNS_config_targetIcon_targetIconList_npm',
    GRIDCOLUMNS_config_targetIcon_targetIconList_messageQueue:
      'GRIDCOLUMNS_config_targetIcon_targetIconList_messageQueue',
    GRIDCOLUMNS_config_targetIcon_targetIconList_cloud:
      'GRIDCOLUMNS_config_targetIcon_targetIconList_cloud',
    GRIDCOLUMNS_config_targetIcon_targetIconList_cluster:
      'GRIDCOLUMNS_config_targetIcon_targetIconList_cluster',
    GRIDCOLUMNS_config_targetIcon_targetIconList_node:
      'GRIDCOLUMNS_config_targetIcon_targetIconList_node',
    GRIDCOLUMNS_config_targetIcon_targetIconList_namespace:
      'GRIDCOLUMNS_config_targetIcon_targetIconList_namespace',
    GRIDCOLUMNS_config_targetIcon_targetIconList_was:
      'GRIDCOLUMNS_config_targetIcon_targetIconList_was',
    GRIDCOLUMNS_config_targetIcon_targetIconList_webserver:
      'GRIDCOLUMNS_config_targetIcon_targetIconList_webserver',
    GRIDCOLUMNS_config_targetIcon_targetIconList_db:
      'GRIDCOLUMNS_config_targetIcon_targetIconList_db',
    GRIDCOLUMNS_config_targetIcon_targetIconList_redis:
      'GRIDCOLUMNS_config_targetIcon_targetIconList_redis',
    GRIDCOLUMNS_config_targetIcon_targetIconList_cubrid:
      'GRIDCOLUMNS_config_targetIcon_targetIconList_cubrid',
    GRIDCOLUMNS_config_targetIcon_targetIconList_mongodb:
      'GRIDCOLUMNS_config_targetIcon_targetIconList_mongodb',
    GRIDCOLUMNS_config_targetIcon_targetIconList_redshift:
      'GRIDCOLUMNS_config_targetIcon_targetIconList_redshift',
    GRIDCOLUMNS_config_targetIcon_targetIconList_singlestore:
      'GRIDCOLUMNS_config_targetIcon_targetIconList_singlestore',

    GRIDCOLUMNS_config_customTargetLink_customTargetLinkList:
      'GRIDCOLUMNS_config_customTargetLink_customTargetLinkList',

    FILTERSEARCH_config_notice_list: 'FILTERSEARCH_config_notice_list',
    FILTERSEARCH_config_notice_selectUserList: 'FILTERSEARCH_config_notice_selectUserList',
    FILTERSEARCH_config_agent_agentList: 'FILTERSEARCH_config_agent_agentList',
    FILTERSEARCH_config_agent_agentList_agentBulkWindow:
      'FILTERSEARCH_config_agent_agentList_agentBulkWindow',
    FILTERSEARCH_config_agent_patchAgentList: 'FILTERSEARCH_config_agent_patchAgentList',
    FILTERSEARCH_config_agent_agentListDetail_agentTarget:
      'FILTERSEARCH_config.agent_agentListDetail_agentTarget',
    FILTERSEARCH_config_license_keyList: 'FILTERSEARCH_config_license_keyList',
    FILTERSEARCH_config_license_targetList: 'FILTERSEARCH_config_license_targetList',
    FILTERSEARCH_config_license_targetList_host: 'FILTERSEARCH_config_license_targetList_host',
    FILTERSEARCH_config_license_targetList_ndm: 'FILTERSEARCH_config_license_targetList_ndm',
    FILTERSEARCH_config_license_targetList_kafka: 'FILTERSEARCH_config_license_targetList_kafka',
    FILTERSEARCH_config_license_targetList_container:
      'FILTERSEARCH_config_license_targetList_container',
    FILTERSEARCH_config_license_targetList_appContainer:
      'FILTERSEARCH_config_license_targetList_appContainer',
    FILTERSEARCH_config_license_targetList_apm: 'FILTERSEARCH_config_license_targetList_apm',
    FILTERSEARCH_config_license_targetList_redis: 'FILTERSEARCH_config_license_targetList_redis',
    FILTERSEARCH_config_license_targetList_postgresql:
      'FILTERSEARCH_config_license_targetList_postgresql',
    FILTERSEARCH_config_license_targetList_mysql: 'FILTERSEARCH_config_license_targetList_mysql',
    FILTERSEARCH_config_license_targetList_sqlServer:
      'FILTERSEARCH_config_license_targetList_sqlServer',
    FILTERSEARCH_config_license_targetList_oracle: 'FILTERSEARCH_config_license_targetList_oracle',
    FILTERSEARCH_config_host_license_issuance_history:
      'FILTERSEARCH_config_host_license_issuance_history',
    FILTERSEARCH_config_database_license_issuance_history:
      'FILTERSEARCH_config_database_license_issuance_history',
    FILTERSEARCH_config_tag_tagValueList: 'FILTERSEARCH_config_tag_tagValueList',
    FILTERSEARCH_config_dataRetention_platformTableList:
      'FILTERSEARCH_config_dataRetention_platformTableList',
    FILTERSEARCH_config_data_metricCollectionList: 'FILTERSEARCH_config_data_metricCollectionList',
    FILTERSEARCH_config_data_statList: 'FILTERSEARCH_config_data_statList',
    FILTERSEARCH_config_customStat_scheduleList: 'FILTERSEARCH_config_customStat_scheduleList',
    FILTERSEARCH_config_customStat_metricMappingValueList:
      'FILTERSEARCH_config_customStat_metricMappingValueList',
    FILTERSEARCH_config_customStat_collectionLogList:
      'FILTERSEARCH_config_customStat_collectionLogList',
    FILTERSEARCH_config_accessPolicy_loginIpControlList:
      'FILTERSEARCH_config_accessPolicy_loginIpControlList',
    FILTERSEARCH_config_accessPolicy_loginFailHistoryList:
      'FILTERSEARCH_config_accessPolicy_loginFailHistoryList',

    FILTERSEARCH_config_targetIcon_targetIconList_host:
      'FILTERSEARCH_config_targetIcon_targetIconList_host',
    FILTERSEARCH_config_targetIcon_targetIconList_network:
      'FILTERSEARCH_config_targetIcon_targetIconList_network',
    FILTERSEARCH_config_targetIcon_targetIconList_npm:
      'FILTERSEARCH_config_targetIcon_targetIconList_npm',
    FILTERSEARCH_config_targetIcon_targetIconList_messageQueue:
      'FILTERSEARCH_config_targetIcon_targetIconList_messageQueue',
    FILTERSEARCH_config_targetIcon_targetIconList_cloud:
      'FILTERSEARCH_config_targetIcon_targetIconList_cloud',
    FILTERSEARCH_config_targetIcon_targetIconList_cluster:
      'FILTERSEARCH_config_targetIcon_targetIconList_cluster',
    FILTERSEARCH_config_targetIcon_targetIconList_node:
      'FILTERSEARCH_config_targetIcon_targetIconList_node',
    FILTERSEARCH_config_targetIcon_targetIconList_namespace:
      'FILTERSEARCH_config_targetIcon_targetIconList_namespace',
    FILTERSEARCH_config_targetIcon_targetIconList_was:
      'FILTERSEARCH_config_targetIcon_targetIconList_was',
    FILTERSEARCH_config_targetIcon_targetIconList_webserver:
      'FILTERSEARCH_config_targetIcon_targetIconList_webserver',
    FILTERSEARCH_config_targetIcon_targetIconList_db:
      'FILTERSEARCH_config_targetIcon_targetIconList_db',
    FILTERSEARCH_config_targetIcon_targetIconList_redis:
      'FILTERSEARCH_config_targetIcon_targetIconList_redis',
    FILTERSEARCH_config_targetIcon_targetIconList_cubrid:
      'FILTERSEARCH_config_targetIcon_targetIconList_cubrid',
    FILTERSEARCH_config_targetIcon_targetIconList_mongodb:
      'FILTERSEARCH_config_targetIcon_targetIconList_mongodb',
    FILTERSEARCH_config_targetIcon_targetIconList_redshift:
      'FILTERSEARCH_config_targetIcon_targetIconList_redshift',
    FILTERSEARCH_config_targetIcon_targetIconList_singlestore:
      'FILTERSEARCH_config_targetIcon_targetIconList_singlestore',

    FILTERSEARCH_config_customTargetLink_customTargetLinkList:
      'FILTERSEARCH_config_customTargetLink_customTargetLinkList',

    TOPBANNER_config_agent_warning: 'TOPBANNER_config_agent_warning',

    TOGGLE_config_agentDetail_info_expanded: 'TOGGLE_config_agentDetail_info_expanded',
    TOGGLE_config_dataCollectionSlide_info_expanded:
      'TOGGLE_config_dataCollectionSlide_info_expanded',
    TOGGLE_config_dataCollectionSlide_targets_expanded:
      'TOGGLE_config_dataCollectionSlide_targets_expanded',
    TOGGLE_config_dataCollectionSlide_metricSetting_expanded:
      'TOGGLE_config_dataCollectionSlide_metricSetting_expanded',
  },
  COMMON: {
    GRIDCOLUMNS_config_tagInformation: 'GRIDCOLUMNS_config_tagInformation',
    GRIDCOLUMNS_config_alertNotification: 'GRIDCOLUMNS_config_alertNotification',
  },
};
